import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ToastyService } from 'ng2-toasty';
import { AuthService } from 'src/app/auth/auth.service';
import { environment } from 'src/environments/environment';
import { MediaService } from './media-service.service';

@Component({
  selector: 'app-media-manager',
  templateUrl: './media-manager.component.html',
  styleUrls: ['./media-manager.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MediaManagerComponent implements OnInit {

  afuConfig: any = {
  };
  authToken = '';
  environment = environment;

  constructor( private authService: AuthService, private mediaService: MediaService, private toastyService: ToastyService ) { }

  @Output() onFileSelect = new EventEmitter();
  @Input() filePath: any;
  @Input() formatsAllowed: string;
  @Input() maxSize: number;
  @Input() square: boolean;
  @ViewChild('selectMediaModal') selectMediaModal;
  modalOpen = false;
  newUpdatedMedia = null;
  file: any;
  initGallery = false;

  ngOnInit(): void {

    this.authToken = this.authService.getToken();


    this.afuConfig = {
      multiple: false,
      formatsAllowed: this.formatsAllowed ? this.formatsAllowed : '.jpg,.png,.jpeg,.svg',
      maxSize: this.maxSize? this.maxSize : 1,
      theme: 'dragNDrop',
      hideSelectBtn: false,
      hideResetBtn: true,
      uploadAPI: {
        url: environment.apiUrl +  '/media/new',
          headers: {
            Authorization : `Bearer ${this.authToken}`
          }
      },
      replaceTexts: {
        selectFileBtn: 'Carica un file dal tuo pc',
        resetBtn: 'Reset',
        uploadBtn: 'Upload file',
        dragNDropBox: 'Seleziona o trascina un file',
        afterUploadMsg_success: 'Upload eseguito!',
        afterUploadMsg_error: 'Upload fallito!'
      }
    };


    this.mediaService.getAllMedia()
    .subscribe((res: {data: any[]}) => {
      this.file = res.data.find(f => f.filename === this.filePath);
    });
}

  DocUpload(event): void{
    this.file = event.body.data;
    this.newUpdatedMedia = event.body.data;
    this.onFileSelect.emit(event.body.data);
  }

  detachFile(): void {
    this.file = null;
    this.onFileSelect.emit(null);
  }

  setFile(event) {

    if (this.square) {
      this.file = event;
      var img = new Image();
      img.src = environment.imageCDN + environment.imageFolder + '/' + this.file.filename;
      img.onload = (image: any) => { 
        if (image.path[0].width !== image.path[0].height) {
          this.toastyService.warning({
            title: 'Devi scegliere un\'immagine quadrata!',
            msg: 'Le Interactions Quadrato magico accettano solo immagini quadrate'
          });
          this.file = null;
        } else {
          this.onFileSelect.emit(event);
          this.initGallery = false;
          this.selectMediaModal.hide();
        }
      }  
    } else { 
      this.onFileSelect.emit(event);
      this.initGallery = false;
      this.selectMediaModal.hide();
    }
    

  }

  fileImage(): string {
    if (this.filePath.search('jpg') !== -1 || this.filePath.search('jpeg') !== -1 || this.filePath.search('png') !== -1) {
      return 'url(' + environment.imageCDN + environment.imageFolder + '/' + this.filePath +')'
    } else {
      return 'url(/assets/images/audio.png)';
    }
  }


}
